import { render, staticRenderFns } from "./NewServiceGroup.vue?vue&type=template&id=10137590&"
import script from "./NewServiceGroup.vue?vue&type=script&lang=js&"
export * from "./NewServiceGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports